import { toast as sonner } from 'sonner'

import getToastDuration from './helpers/getToastDuration'
import SystemToastMessage from './SystemToastMessage'
import { type ToastProps, type SystemToastOptions } from './types'

export type SonnerToastProps = {
  toast: Omit<ToastProps, 'id' | 'dismiss'>
  options?: SystemToastOptions
}

export const dismissToast = (id: SystemToastOptions['id']) => {
  if (!id) return

  sonner.dismiss(id)
}

export const sonnerToast = ({ toast, options }: SonnerToastProps) =>
  sonner.custom(
    (id) => (
      <SystemToastMessage
        id={id}
        dismiss={sonner.dismiss}
        {...toast}
        dataTestId={options?.dataTestId}
        isIcon={options?.isIcon}
        customIconRsc={options?.customIconRsc}
        iconVariant={options?.iconVariant}
        actionButton={options?.actionButton}
      />
    ),
    {
      dismissible: true,
      duration: getToastDuration(toast),
      toasterId: 'system-bottom-toaster',
      id: options?.id ?? `${toast.type}:${toast.title}`,
      ...options,
    },
  )
